import React from 'react';
import { Typography, Empty } from 'antd';
import { useAuthStore } from '../../stores/authStore';
import OverviewDashboard from './components/OverviewDashboard';
import TeacherOverview from './components/TeacherOverview';
import StudentOverview from './components/StudentOverview';

const { Title, Text } = Typography;

const ROLE_LABEL: Record<string, string> = {
  admin: '系统管理员',
  teacher: '教师',
  dean: '院长',
  deputydean: '副院长',
  student: '学生',
  sci_assistant: '少科院助理',
};

/** 管理类角色共用「全机构口径」看板 */
const ADMIN_LIKE_ROLES = ['admin', 'dean', 'deputydean', 'sci_assistant'];

const DashboardPage: React.FC = () => {
  const user = useAuthStore((s) => s.user);
  const role = user?.role || 'student';

  const renderBody = () => {
    if (ADMIN_LIKE_ROLES.includes(role)) return <OverviewDashboard />;
    if (role === 'teacher') return <TeacherOverview />;
    if (role === 'student') return <StudentOverview />;
    return <Empty description="暂无可展示的看板" />;
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <Title level={4} style={{ margin: 0 }}>
          欢迎回来，{user?.real_name} 👋
        </Title>
        <Text type="secondary">角色：{ROLE_LABEL[role] || role}</Text>
      </div>
      {renderBody()}
    </div>
  );
};

export default DashboardPage;
